import { useEffect, useState } from "react";
// custom hook
import useGetData from "../../../hook/getData.tsx";
import useDeleteData from "../../../hook/deleteData.tsx";
import useParamData from "../../../hook/paramData.tsx";
import useSendData from "../../../hook/sendData.tsx";
// react query
import { GetPhotographer } from "../../../services/admin/user/photographer/getPhotographer.tsx";
import { DeletePhotographer } from "../../../services/admin/user/photographer/deletePhotographer.tsx";
import { StatusPhotographer } from "../../../services/admin/user/photographer/statusPhotographer.tsx";
import { FilterPhotographer } from "../../../services/admin/user/photographer/filterPhotographer.tsx";

export const PhotographerList = () => {
    const [id, setid] = useState<string | number>('');
    const [title, setTitle] = useState<string>('');
    const [items, setItems] = useState<any>();
    // actions
    let deleteData, filterData, statusData
    const { data, isLoading, refetch } = useGetData(['users'], GetPhotographer);
    useEffect(() => {
        refetch()
        setItems(data?.photographers);
    }, [data])
    const { deleteItem } = useDeleteData(deleteData, DeletePhotographer, refetch);
    const { send } = useParamData(filterData, FilterPhotographer, setItems)
    const { send: statusChange } = useSendData(statusData, StatusPhotographer, null, null, null, refetch)
    let changeData = (id: number | string, title: string) => {
        setid(id)
        setTitle(title)
    }
    const onDelete = (id: number | string) => {
        deleteItem(id)
    }
    const fileterUser = (event: any) => {
        send(event.target.value)
    }
    const changeStatus = (event: any, id: number) => {
        let value = Number(event.target.value);
        const data = {
            status: value,
            id: id,
        }
        statusChange(data)
    }
    return { id, title, items, isLoading, changeData, onDelete, fileterUser, changeStatus }
}